import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function TournamentParticipationConfirmationsReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_PARTICIPATION_CONFIRMATIONS}
      description="Review participation confirmation responses for the selected tournament."
      sectionTitle="Confirmation status"
      sectionHint="Choose which response statuses should appear in the report."
      options={[
        {
          field: 'isShowAccepted',
          label: 'Accepted',
          hint: 'Include accepted participation requests.',
          initialValue: true
        },
        {
          field: 'isShowRejected',
          label: 'Rejected',
          hint: 'Include rejected participation requests.',
          initialValue: true
        },
        {
          field: 'isShowUnresponded',
          label: 'Pending',
          hint: 'Include requests that have not been answered.',
          initialValue: true
        },
        {
          field: 'isShowNotSent',
          label: 'Not sent',
          hint: 'Include schools that have not received a request.',
          initialValue: true
        }
      ]}
    />
  );
}
